/* eslint-disable @angular-eslint/prefer-standalone */
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ENV_RIBBON } from 'src/app/shared/utils/env-ribbon.utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly title = signal('portal-antecipagrao');
  protected readonly envRibbon = ENV_RIBBON;
}
